var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillAndExpertise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 10.5,
    fill: "white",
    stroke: "#959595"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30C17.358 30 17.2393 29.952 17.144 29.856C17.0487 29.76 17.0007 29.641 17 29.499C16.9993 29.357 17.0473 29.2383 17.144 29.143C17.2407 29.0477 17.3593 29 17.5 29H24.5C24.642 29 24.7607 29.048 24.856 29.144C24.9513 29.24 24.9993 29.359 25 29.501C25.0007 29.643 24.9527 29.7617 24.856 29.857C24.7593 29.9523 24.6407 30 24.5 30H17.5ZM17.8 28C17.5733 28 17.3833 27.9227 17.23 27.768C17.0767 27.6133 17 27.4213 17 27.192V19.867C17 19.6923 17.0267 19.5243 17.08 19.363C17.1333 19.2017 17.2143 19.0467 17.323 18.898L20.066 15.246C20.1273 15.164 20.199 15.1027 20.281 15.062C20.363 15.0213 20.4553 15.0007 20.558 15H21.448C21.5467 15 21.637 15.0207 21.719 15.062C21.801 15.1033 21.8727 15.1647 21.934 15.246L24.677 18.898C24.7843 19.046 24.865 19.201 24.919 19.363C24.973 19.525 25 19.693 25 19.867V27.192C25 27.4213 24.9233 27.6133 24.77 27.768C24.6167 27.9227 24.4267 28 24.2 28H17.8ZM18 27H24V24.114L21 21.114L18 24.114V27ZM18 22.712L20.5 20.212V16.327L18 19.675V22.712ZM24 22.712V19.675L21.5 16.327V20.212L24 22.712Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillAndExpertise);
export default __webpack_public_path__ + "static/media/SkillAndExpertise.c7af8105cf5fb0dfc1f6fe823b8f49a5.svg";
export { ForwardRef as ReactComponent };